import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { DataTablesModule } from 'angular-datatables';
import { VolunteerListComponent } from './components/volunteer-list/volunteer-list.component';
import { VolunteerActionCellComponent } from './components/volunteer-action-cell/volunteer-action-cell.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { ToastModule } from 'app/toast/toast.module';
import { VolunteerStatusCellComponent } from './components/volunteer-status-cell/volunteer-status-cell.component';

@NgModule({
  declarations: [
    VolunteerListComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    ToastModule,
    DataTablesModule,
    VolunteerStatusCellComponent,
    VolunteerActionCellComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    VolunteerListComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VolunteersModule { }
